/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import TemplateDetailAuditor from '@/modules/templates/components/TemplateDetailsAuditor';
import TemplateDetailsAuditionDate from '@/modules/templates/components/TemplateDetailsAuditionDate';
import TemplateDetailsLocation from '@/modules/templates/components/TemplateDetailsLocation';
import TemplateDetailsNumber from '@/modules/templates/components/TemplateDetailsNumber';
import TemplateDetailsSelect from '@/modules/templates/components/TemplateDetailsSelect';
import TemplateDetailsText from '@/modules/templates/components/TemplateDetailsText';
import TemplateDetailsInSituMeasure from '@/modules/templates/components/TemplateDetailsInSituMeasure';
import TemplateDetailObjective from '@/modules/templates/components/TemplateDetailsObjective';
import TemplateDetailSummary from '@/modules/templates/components/TemplateDetailsSummary';
import TemplateDetailEvolution from '@/modules/templates/components/TemplateDetailsEvolution';
import TemplateDetailsRichText from '@/modules/templates/components/TemplateDetailsRichText';
import TemplateDetailsAuditDateRange from '@/modules/templates/components/TemplateDetailsAuditDateRange';
import TemplateDetailContactInformation from '@/modules/templates/components/TemplateDetailContactName';
import TemplateDetailPoolsNumbers from '@/modules/templates/components/TemplateDetailPoolsNumbers';

const WrapperFieldType = ({ type, question, sectionId, isCover, runAudit, isContact }) => {

  const render = useMemo(() => {
    switch (type) {
      case 'audit_date':
        return <TemplateDetailsAuditDateRange question={ question } runAudit={ runAudit } isCover={ isCover || isContact } />;
      case 'date':
        return <TemplateDetailsAuditionDate question={ question } runAudit={ runAudit } isCover={ isCover || isContact } />;
      case 'objective':
        return <TemplateDetailObjective question={ question } runAudit={ runAudit } />;
      case 'evolution':
        return <TemplateDetailEvolution question={ question } runAudit={ runAudit } />;
      case 'summary':
        return <TemplateDetailSummary question={ question } runAudit={ runAudit } />;
      case 'location':
        return <TemplateDetailsLocation key={`${question?._id}-${sectionId}`} question={ question } runAudit={ runAudit } />;
      case 'number':
        return <TemplateDetailsNumber question={ question } runAudit={ runAudit } sectionId={ sectionId } isCover={ isCover || isContact } />;
      case 'select':
        return <TemplateDetailsSelect question={ question } runAudit={ runAudit } sectionId={ sectionId } isCover={ isCover || isContact } />;
      case 'auditor':
        return <TemplateDetailAuditor question={ question } runAudit={ runAudit } />;
      case 'readingRegistry':
        return <TemplateDetailsInSituMeasure question={ question } runAudit={ runAudit } sectionId={ sectionId } />;
      case 'paragraph':
        return <TemplateDetailsRichText question={ question } runAudit={ runAudit } />;
      case 'pools_reported':
        return <TemplateDetailPoolsNumbers question={question} isCover={isCover || isContact} runAudit={runAudit}/>;
      case 'pools_audited':
        return <TemplateDetailPoolsNumbers question={question} isCover={isCover || isContact} runAudit={runAudit}/>;
      case 'pools_not_audited':
        return <TemplateDetailPoolsNumbers question={question} isCover={isCover || isContact} runAudit={runAudit}/>;
      case 'contact_information':
        return <TemplateDetailContactInformation question={question} isCover={isCover || isContact} runAudit={runAudit} />;
      default:
        return <TemplateDetailsText question={ question } runAudit={ runAudit } sectionId={ sectionId } isContact={ isContact } isCover={ isCover || isContact } />;
    }
  }, [isContact, isCover, question, runAudit, sectionId, type]);

  return (
    <div className="py-2">{ render }</div>
  );
};

WrapperFieldType.propTypes = {
  type: PropTypes.string,
  question: PropTypes.object,
  isCover: PropTypes.bool,
  isContact: PropTypes.bool,
  sectionId: PropTypes.string,
  runAudit: PropTypes.bool,
};

export default memo(WrapperFieldType);
